import { Injectable } from '@angular/core';
import { User } from 'src/types/graphql';

@Injectable({ providedIn: 'root' })
export class UserNameService {
  name(user: Partial<User>, shortened?: boolean, forceName?: boolean): string {
    if (!user) return '';
    if (user.anonymised) return 'Profilo non attivo';
    if (user.businessName && !forceName) return user.businessName;
    else if (shortened) return `${user.name}`;
    else return `${user.name}${user.surname ? ' ' + user.surname : ''}`;
  }
}
